import script from "./main04Swiper.vue?vue&type=script&setup=true&name=Prod04Swiper&lang=js"
export * from "./main04Swiper.vue?vue&type=script&setup=true&name=Prod04Swiper&lang=js"

const __exports__ = script;

export default __exports__